// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"366":"af6d87d9","594":"d963052e","830":"24409ee3"}[chunkId] + ".js";
};